import brochure from './Brochure.png';
import calendar from './Calender.png';
import card from './GreetingCard.png';
import folder from './Folder.png';

const images = {
    brochure, calendar, card, folder
}

export default images;